<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    max-width="500"
  >
    <v-card class="modal-card">
      <v-card-title class="modal-title">Detalles del Correo</v-card-title>

      <v-card-text class="modal-body">
        <div class="info-pair">
          <span class="label">Nombre:</span>
          <span
            >{{ correo?.title }} {{ correo?.name }} {{ correo?.lastname }}</span
          >
        </div>
        <div class="info-pair">
          <span class="label">Email:</span>
          <span>{{ correo?.email }}</span>
        </div>
        <div class="info-pair">
          <span class="label">Fecha:</span>
          <span>{{ dateFormat(correo?.created_at) }}</span>
        </div>
        <div class="info-pair">
          <span class="label">Asunto:</span>
          <span>{{ correo?.subject }}</span>
        </div>
        <div class="info-pair">
          <span class="label">Mensaje:</span>
          <span class="message">{{ correo?.message }}</span>
        </div>
      </v-card-text>

      <v-card-actions class="modal-actions">
        <button class="close-btn" @click="$emit('update:modelValue', false)">Cerrar</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps } from "vue";
import { formatDate } from "@/kernel/utils";

defineProps({
  modelValue: Boolean,
  correo: Object,
});

const dateFormat = (date) => {
  return formatDate(date);
};
</script>

<style scoped>
.modal-card {
  padding: 16px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.modal-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #ff9800;
  padding-bottom: 8px;
}

.modal-body {
  font-size: 0.95rem;
  color: #444;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 0;
}

.info-pair {
  display: flex;
  flex-direction: column;
  background-color: #f9f9f9;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #eee;
}

.label {
  font-weight: 600;
  color: #ff9800;
  margin-bottom: 4px;
}

.message {
  white-space: pre-wrap;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding: 16px;
}

.close-btn {
  padding: 8px 18px;
  background-color: #ff9800;
  border: none;
  border-radius: 10px;
  color: white;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #868482b0;
}

</style>
